<template>
  <div class="image-adv-selector">
    <div class="title-selector">
      <div class="title">添加图片</div>
      <p class="tips">{{ tplTip }}</p>
    </div>
    <div class="body-selector">
      <image-link-editor
        v-model="$$FormData.imageList"
        :limit="linkLimit"
        :type="$$FormData.image_tpl === 'hotarea' ? 'hotarea' : 'link'"
        title-placeholder="建议10个字以内，可不填"
        add-text="添加背景图"
      >
        <template #item-extra="{ item }">
          <div class="ignore-drag" style="padding-top: 12px" @mousedown.stop>
            <el-switch :value="item.enabled !== false" active-text="启用" @change="$set(item, 'enabled', $event)" />
            <p class="tips">展示排期（北京时间，留空表示不限制）</p>
            <el-date-picker :value="item.start_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="上架时间" size="mini" @input="setTime(item, 'start_time', $event)" />
            <el-date-picker :value="item.end_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="下架时间" size="mini" @input="setTime(item, 'end_time', $event)" />
            <p>{{ scheduleStatus(item) }}</p>
          </div>
        </template>
      </image-link-editor>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageAdvSelector',
  methods: {
    // 固定格式的北京时间字符串可直接比较，非法区间不写入装修表单。
    setTime(item, field, value) {
      const start = field === 'start_time' ? value : item.start_time
      const end = field === 'end_time' ? value : item.end_time
      if (start && end && end <= start) {
        this.$message.error('下架时间必须晚于上架时间')
        return
      }
      this.$set(item, field, value || '')
    },
    // 状态仅用于运营提示，实际展示由服务端时间决定。
    scheduleStatus(item) {
      if (item.enabled === false) return '已停用'
      const now = Date.now()
      const timestamp = value => Date.parse(value.replace(' ', 'T') + '+08:00')
      if (item.end_time && now >= timestamp(item.end_time)) return '已结束'
      if (item.start_time && now < timestamp(item.start_time)) return '待开始'
      return '展示中'
    }
  },
  computed: {
    // 最大个数
    linkLimit() {
      if (this.$$FormData.image_tpl === 'nav-slide') return 15
      return 10
    },
    // 提示信息
    tplTip() {
      switch (this.$$FormData.image_tpl) {
        case 'single':
          return '最多添加 10 个广告，鼠标拖拽调整广告顺序，建议宽度750像素'
        case 'swiper':
          return '最多添加 10 个广告，鼠标拖拽调整广告顺序，建议尺寸750x350像素'
        case 'big-slide':
          return '最多添加 10 个广告，鼠标拖拽调整广告顺序，建议宽度670像素'
        case 'small-slide':
          return '最多添加 10 个广告，鼠标拖拽调整广告顺序，建议宽度305像素'
        case 'nav-slide':
          return '最多添加 15 个广告，鼠标拖拽调整广告顺序，建议宽度142像素'
        case 'hotarea':
          return '最多添加 10 个广告，鼠标拖拽调整广告顺序，建议宽度750像素, 高度1000像素以内, 单张图片大小200kb以内'
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.image-adv-selector {
  .title-selector {
    padding: 12px 16px;
    box-sizing: border-box;
    background-color: #ffffff;
    .title {
      color: #323233;
      font-size: 14px;
    }
    .tips {
      color: #969799;
      font-size: 12px;
      line-height: 18px;
      margin-top: 10px;
    }
  }
  .body-selector {
    padding: 12px 16px;
    background-color: #f7f8fa;
    overflow: hidden;
  }
}
</style>
